<template>
  <div id="app">
    <router-view></router-view>
    <CustomConfirmDialog
      :visible="confirmDialogState.visible"
      :title="confirmDialogState.title"
      :message="confirmDialogState.message"
      :type="confirmDialogState.type"
      :confirm-button-text="confirmDialogState.confirmButtonText"
      :cancel-button-text="confirmDialogState.cancelButtonText"
      :close-on-click-modal="confirmDialogState.closeOnClickModal"
      :width="confirmDialogState.width"
      :z-index="confirmDialogState.zIndex"
      @confirm="confirmActiveDialog"
      @cancel="cancelActiveDialog"
    />
  </div>
</template>

<script setup>
import CustomConfirmDialog from "@/components/Custom/CustomConfirmDialog.vue";
import {
  cancelActiveDialog,
  confirmActiveDialog,
  confirmDialogState,
} from "@/utils/customConfirmDialog";
</script>

<style>
#app {
  background: linear-gradient(180deg, #f0f5fc 0%, #f4f5f7 100%);
  /* background: linear-gradient(to bottom right, #1d3b45, #0a1b37); */
  height: 100%;
}
</style>
